(ns common.schema.entities.ai-task-config-override.core
  (:require
   [common.schema.entities.ai-task-config-override.permissions :as permissions]
   [common.schema.entities.ai-task-config-override.schema :as schema]))

(def entity-type-definition
  {:entity-type                          :entity.type/ai-task-config-override
   :schema                               schema/schema
   :name                                 {:en "AI task configuration override"}
   :plural                               {:en "AI task configuration overrides"}
   :icon                                 :fa-code-branch
   :display-name-fn                      (fn [{:keys [entity]}]
                                           (some-> entity
                                                   :ai-task-config-override/task-type
                                                   name))
   :display-name/depends-on              [:ai-task-config-override/task-type]
   :permissions                          {:creatable?   true
                                          :disableable? true}
   :entity/mcp-blacklisted?              true
   :read-permissions-check-fn            permissions/read-permissions?
   :disable-permissions-check-fn         permissions/disable-permissions?})
